/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowApplicationsControllerFindActivitiesQueryResponse, WorkflowApplicationsControllerFindActivitiesPathParams, WorkflowApplicationsControllerFindActivitiesQueryParams, WorkflowApplicationsControllerFindActivities401, WorkflowApplicationsControllerFindActivities403 } from "../../models/workflowsController/WorkflowApplicationsControllerFindActivities";

function getWorkflowApplicationsControllerFindActivitiesUrl(id: WorkflowApplicationsControllerFindActivitiesPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/workflow-applications/${id}/activities` as const }  
  return res
}

/**
 * @summary Curated activity history for a workflow application
 * {@link /api/v1/workflow-applications/:id/activities}
 */
export async function workflowApplicationsControllerFindActivities(id: WorkflowApplicationsControllerFindActivitiesPathParams["id"], params?: WorkflowApplicationsControllerFindActivitiesQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<WorkflowApplicationsControllerFindActivitiesQueryResponse, ResponseErrorConfig<WorkflowApplicationsControllerFindActivities401 | WorkflowApplicationsControllerFindActivities403>, unknown>({ method : "GET", url : getWorkflowApplicationsControllerFindActivitiesUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}